import { render, staticRenderFns } from "./ConsentPreferencesLink.vue?vue&type=template&id=66111bef&"
import script from "./ConsentPreferencesLink.vue?vue&type=script&lang=js&"
export * from "./ConsentPreferencesLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports